<template>
  <div class="w-full bg-slate-800 border border-slate-700 rounded-lg overflow-hidden shadow-lg">
    <div class="bg-slate-700 py-1.5 text-center border-b border-slate-600">
      <h3 class="text-[15px] font-bold text-white tracking-widest">{{ title }}</h3>
    </div>

    <div class="flex flex-wrap justify-center gap-1 p-1">
      <div 
        v-for="(num, index) in normalizedNumbers" 
        :key="index"
        class="w-[calc(20%-4px)] relative bg-slate-900 border border-slate-700 rounded py-2.5 h-[42px] flex items-center justify-center overflow-hidden"
      >
        <span 
          v-if="showLetters" 
          class="absolute z-10 top-0.5 left-1 text-[10px] font-bold text-red-500 leading-none"
        >
          {{ getLetter(index) }}
        </span>
        
	<Transition name="slot-roll" mode="out-in" :duration="{ enter: 20700, leave: 300 }">
          <span 
            :key="`grid-${index}-${num}`"
            class="absolute w-full text-center text-[17px] font-bold tracking-wider z-0"
            :class="{ 'text-white': num !== '----' && num !== '', 'text-slate-600': num === '----' || num === '' }"
          >
            {{ num !== '' ? num : '----' }}
          </span>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  title: String,
  numbers: Array,
  showLetters: Boolean,
  totalSlots: Number,
  letterStartCode: { type: Number, default: 65 } 
})

const normalizedNumbers = computed(() => {
  if (!props.numbers) return []
  const result = [...props.numbers].map(n => (n && n.trim() !== '') ? n : '----');
  while (result.length < (props.totalSlots || 10)) {
    result.push('----')
  }
  return result
})

const getLetter = (index: number) => {
  return String.fromCharCode(props.letterStartCode + index)
}
</script>
